import { getKcToken, isValidToken } from 'src/keycloak';
import { DEFAULT_APPLICATION_ROUTE } from 'src/utils/constants';

const PublicRoute = ({ element }) => {
  const isAuthenticated = isValidToken(getKcToken());

  if (isAuthenticated) {
    window.location.replace(DEFAULT_APPLICATION_ROUTE);
    return null;
  }

  return element;
};

export default PublicRoute;
